module.exports = "/static/assets/3940587dc72db305766e163b38ea3a7b.png";